<template>
    <SubSectionHeader>
        <Text as="h6" weight="600">{{ sectionTitle }}</Text>
        <slot name="button"></slot>
    </SubSectionHeader>
    <div class="subscore-container" :class="{ 'pdf-shadow-fix': applyPdfShadowFix }">
        <div v-for="subScore in subScores" class="subscore-item">
            <div style="margin-top: 2px">
                <ScorecardDonut
                    :width="44"
                    :strokeWidth="2"
                    :compact="true"
                    :hidden="isLoading"
                    :score="isLoading ? 0 : subScore.score"
                />
            </div>
            <Spacer width="1.5rem" />
            <div>
                <Text as="p" size="f-7" weight="500">{{ subScore.title }}</Text>
                <Spacer height="0.25rem" />
                <Text as="p" size="f-8">
                    <template v-if="subScore.copies">
                        {{ getSectionCopy(subScore.copies, subScore.score)[0] }}
                    </template>
                    <template v-else>
                        {{ subScore.copy }}
                    </template>
                </Text>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Spacer, Text } from '@opteo/components-next'

import { getSectionCopy } from './utils'
import ScorecardDonut from './ScorecardDonut.vue'
import SubSectionHeader from './SubSectionHeader.vue'

import type { SubScore } from '@/composition/toolkit/scorecard/types'

type Props = {
    isLoading?: boolean
    applyPdfShadowFix?: boolean
    sectionTitle: string
    subScores: SubScore[]
}

withDefaults(defineProps<Props>(), {
    isLoading: false,
    applyPdfShadowFix: false,
})
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
@import '@/assets/css/variables.scss';

.subscore-container {
    @include container;
    @include br-20;
    @include w-100;
}

.subscore-item {
    @include ph-24;
    @include pv-20;
    @include flex;
    border-bottom: 1px solid $opteo-light-gray;
}
.subscore-item:last-child {
    border-bottom: none;
}
</style>
